import SuppliesOrdersList from './SuppliesOrdersList'

export default {
  list: SuppliesOrdersList,
}
